import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import RequestPromoteFlowStep from './RequestPromoteFlowStep'

class DatesDetailsStep extends RequestPromoteFlowStep {
  constructor(component: ReactNode) {
    super(i18n.t('contract_versions.flows.request_promote.steps.dates.title'), component)
  }
}

export default DatesDetailsStep
